import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginService } from './login.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LogoutComponent } from './logout/logout.component';
import { TokenLoginComponent } from './token-login/token-login.component';
import { WsgSharedModule }  from '@morningstar/wsg/shared';

@NgModule({
  imports: [
    CommonModule,
    WsgSharedModule,
    RouterModule.forChild([
      { path: 'login', component: LoginComponent },
      { path: 'token-login', component: TokenLoginComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'logout', component: LogoutComponent },
      { path: 'reset-password', component: ResetPasswordComponent }
    ])
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LogoutComponent,
    TokenLoginComponent
  ],
  providers: [
    LoginService
  ]
})
export class LoginModule { }
